<template>
	<ViewPhoto
		:key="photosIndex"
		v-if="imageShow && images.length"
		:images="
			images.map((item) => {
				return { asset_url: getUrl(item), asset_key: getUrl(item) };
			})
		"
		:index="photosIndex"
		@close="imageShow = false"
	/>
	<input
		type="file"
		hidden
		id="upload-images-notification"
		@change="uploadChange"
		multiple
		accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf,application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/png, image/jpeg, image/jpg"
	/>
	<DaModalFrame v-model:open="modalIsOpen">
		<ConfirmSend
			@close="cancel"
			@submit="submitConfirm"
			@openViewPhoto="openMediaPopup(0)"
			:notification="notification"
			:inProgress="inProgress"
		/>
	</DaModalFrame>
	<div class="pb-30 px-10 md-down:px-4">
		<div
			class="
				__report-lesson__header
				pt-10
				pb-10
				flex flex-nowrap
				justify-between
				items-center
			"
		>
			<div
				class="
					__record__title
					text-neutral-500
					font-semibold
					whitespace-nowrap
					flex flex-nowrap
					items-center
					text-4xl
					cursor-pointer
				"
				@click="$router.push('/notifications')"
			>
				<svg
					class="mr-2"
					width="28"
					height="28"
					viewBox="0 0 28 28"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M17.5 7L10.5 14L17.5 21"
						stroke="#94A3B8"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
				Tạo thông báo
			</div>
			<button
				type="button"
				class="
					button-p
					text-center
					w-fit
					btn--text
					text-neutral-500
					hover:text-neutral-600
				"
				@click="$router.push('/notifications')"
			>
				<svg
					width="16"
					height="16"
					viewBox="0 0 16 16"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					class="mr-2 text-neutral-400"
				>
					<path
						d="M1.5 7.99996L0.719131 7.37526L0.219375 7.99996L0.719131 8.62465L1.5 7.99996ZM7.5 8.99996C8.05228 8.99996 8.5 8.55224 8.5 7.99996C8.5 7.44767 8.05228 6.99996 7.5 6.99996V8.99996ZM3.3858 4.04193L0.719131 7.37526L2.28087 8.62465L4.94754 5.29132L3.3858 4.04193ZM0.719131 8.62465L3.3858 11.958L4.94754 10.7086L2.28087 7.37526L0.719131 8.62465ZM1.5 8.99996H7.5V6.99996H1.5V8.99996Z"
						fill="currentColor"
					/>
					<path
						d="M7.78738 13.3439L8.31032 12.4915L7.78738 13.3439ZM6.97976 12.3905L6.05301 12.7662L6.97976 12.3905ZM14.499 12.5015L15.3875 12.9603L14.499 12.5015ZM12.7525 13.981L12.4461 13.0291L12.7525 13.981ZM14.499 3.49854L15.3875 3.0398L14.499 3.49854ZM13.8333 6.81921V9.18087H15.8333V6.81921H13.8333ZM7.83325 5.42133V5.29122H5.83325V5.42133H7.83325ZM9.58524 12.7782C8.62733 12.6186 8.43551 12.5683 8.31032 12.4915L7.26445 14.1962C7.80406 14.5273 8.47961 14.6216 9.25644 14.751L9.58524 12.7782ZM5.83325 10.7107C5.83325 11.4979 5.81518 12.1795 6.05301 12.7662L7.90651 12.0148C7.85132 11.8787 7.83325 11.6814 7.83325 10.7107H5.83325ZM8.31032 12.4915C8.12826 12.3798 7.98675 12.2128 7.90651 12.0148L6.05301 12.7662C6.29374 13.36 6.71828 13.8612 7.26445 14.1962L8.31032 12.4915ZM13.8333 9.18087C13.8333 10.0882 13.8325 10.7099 13.7946 11.1876C13.7573 11.6573 13.6894 11.8898 13.6104 12.0428L15.3875 12.9603C15.6428 12.4658 15.742 11.929 15.7883 11.3458C15.834 10.7705 15.8333 10.0557 15.8333 9.18087H13.8333ZM9.25644 14.751C10.1198 14.8949 10.8251 15.0132 11.4002 15.0628C11.9832 15.113 12.5291 15.1035 13.0589 14.9329L12.4461 13.0291C12.2822 13.0819 12.0416 13.1107 11.5719 13.0702C11.0943 13.029 10.4806 12.9275 9.58524 12.7782L9.25644 14.751ZM13.6104 12.0428C13.3679 12.5125 12.9493 12.8671 12.4461 13.0291L13.0589 14.9329C14.0653 14.609 14.9025 13.8997 15.3875 12.9603L13.6104 12.0428ZM9.58645 3.22163C10.4814 3.07248 11.0948 2.97099 11.5722 2.92986C12.0416 2.88942 12.2822 2.91819 12.4461 2.97096L13.0589 1.06717C12.5292 0.896646 11.9834 0.887021 11.4005 0.937243C10.8256 0.986778 10.1206 1.10503 9.25766 1.24885L9.58645 3.22163ZM15.8333 6.81921C15.8333 5.9444 15.834 5.22954 15.7883 4.65428C15.742 4.07104 15.6428 3.53429 15.3875 3.0398L13.6104 3.95728C13.6894 4.1103 13.7573 4.34283 13.7946 4.81252C13.8325 5.29019 13.8333 5.91191 13.8333 6.81921H15.8333ZM12.4461 2.97096C12.9493 3.13294 13.3679 3.48755 13.6104 3.95728L15.3875 3.0398C14.9025 2.10035 14.0653 1.39113 13.0589 1.06717L12.4461 2.97096ZM9.25766 1.24885C8.83685 1.31898 8.47124 1.37935 8.17099 1.45102C7.85987 1.52528 7.55473 1.62545 7.26252 1.80503L8.30967 3.50898C8.35038 3.48397 8.42887 3.44565 8.63532 3.39637C8.85265 3.3445 9.13857 3.29628 9.58645 3.22163L9.25766 1.24885ZM7.83325 5.29122C7.83325 4.83715 7.83381 4.5472 7.84925 4.3243C7.86391 4.11256 7.88881 4.02884 7.90679 3.98457L6.05387 3.23179C5.92477 3.54955 5.87613 3.86701 5.85403 4.1861C5.8327 4.49405 5.83325 4.86461 5.83325 5.29122H7.83325ZM7.26252 1.80503C6.71792 2.13971 6.29446 2.63958 6.05387 3.23179L7.90679 3.98457C7.98699 3.78717 8.12814 3.62054 8.30967 3.50898L7.26252 1.80503Z"
						fill="currentColor"
					/>
				</svg>
				Thoát
			</button>
		</div>
		<div class="bg-white rounded-xl p-6 shadow-sm">
			<div class="flex justify-between items-center">
				<div class="text-gray-600 font-semibold text-lg">
					Nội dung thông báo
				</div>
				<div class="flex items-center justify-end gap-8" v-if="false">
					<div
						class="
							flex
							items-center
							text-yellow-600
							hover:text-yellow-700
							font-semibold
							cursor-pointer
							text-sm
						"
					>
						<svg
							class="mr-2"
							width="16"
							height="16"
							viewBox="0 0 16 16"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M2.5 1C1.94772 1 1.5 1.44772 1.5 2V3C1.5 3.55228 1.94772 4 2.5 4H3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V4H13.5C14.0523 4 14.5 3.55228 14.5 3V2C14.5 1.44772 14.0523 1 13.5 1H10C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1H2.5ZM5.5 5C5.77614 5 6 5.22386 6 5.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5L5 5.5C5 5.22386 5.22386 5 5.5 5ZM8 5C8.27614 5 8.5 5.22386 8.5 5.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V5.5C7.5 5.22386 7.72386 5 8 5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V5.5Z"
								fill="currentColor"
							/>
						</svg>
						<span class="mt-0.5">Huỷ Bỏ</span>
					</div>
					<div
						class="
							flex
							items-center
							text-yellow-600
							hover:text-yellow-700
							font-semibold
							cursor-pointer
							text-sm
						"
						@click="submit"
					>
						<svg
							class="mr-2"
							width="16"
							height="16"
							viewBox="0 0 16 16"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M11.3333 2H3.33333C2.59333 2 2 2.6 2 3.33333V12.6667C2 13.4 2.59333 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V4.66667L11.3333 2ZM8 12.6667C6.89333 12.6667 6 11.7733 6 10.6667C6 9.56 6.89333 8.66667 8 8.66667C9.10667 8.66667 10 9.56 10 10.6667C10 11.7733 9.10667 12.6667 8 12.6667ZM10 6H3.33333V3.33333H10V6Z"
								fill="#E5A42B"
							/>
						</svg>
						<span class="mt-0.5">Lưu</span>
					</div>
				</div>
			</div>
			<div class="rounded-lg p-4 border border-gray-100 mt-4">
				<div class="flex md-down:flex-col w-full gap-4">
					<div
						class="
							uppercase
							text-neutral-400 text-sm
							font-medium
							tracking-wide
							w-60
						"
					>
						Tiêu đề
					</div>
					<div class="w-full input-group">
						<input
							class="title"
							type="text"
							placeholder="Tiêu đề thông báo"
							v-model="title"
							style="border-color: #e8e8e8"
						/>
					</div>
				</div>
				<div class="flex md-down:flex-col w-full gap-4 mt-8">
					<div
						class="
							uppercase
							text-neutral-400 text-sm
							font-medium
							tracking-wide
							w-60
						"
					>
						nội dung
					</div>
					<div class="w-full">
						<textarea
							placeholder="Nội dung thông báo"
							v-model="content"
						></textarea>
					</div>
				</div>
				<div class="flex md-down:flex-col w-full gap-4 mt-8">
					<div
						class="
							uppercase
							text-neutral-400 text-sm
							font-medium
							tracking-wide
							w-60
						"
					>
						TỆP ĐÍNH KÈM
					</div>
					<div class="w-full flex gap-8">
						<div v-if="images.length || files.length">
							<div
								v-if="images.length"
								class="grid grid-cols-2 gap-4"
							>
								<div
									v-for="(image, index) in images"
									:key="index"
									class="rounded-lg relative"
								>
									<div
										class="
											absolute
											top-2
											right-2
											cursor-pointer
										"
										@click="removeImage(index)"
									>
										<svg
											width="24"
											height="24"
											viewBox="0 0 12 12"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<g opacity="0.5">
												<rect
													width="12"
													height="12"
													rx="6"
													fill="black"
												/>
											</g>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M3.73483 3.73483C3.88128 3.58839 4.11872 3.58839 4.26517 3.73483L6.25 5.71967L8.23484 3.73483C8.38128 3.58839 8.61872 3.58839 8.76516 3.73483C8.91161 3.88128 8.91161 4.11872 8.76516 4.26517L6.78033 6.25L8.76516 8.23484C8.91161 8.38128 8.91161 8.61872 8.76516 8.76516C8.61872 8.91161 8.38128 8.91161 8.23484 8.76516L6.25 6.78033L4.26517 8.76516C4.11872 8.91161 3.88128 8.91161 3.73483 8.76516C3.58839 8.61872 3.58839 8.38128 3.73483 8.23484L5.71967 6.25L3.73483 4.26517C3.58839 4.11872 3.58839 3.88128 3.73483 3.73483Z"
												fill="white"
											/>
										</svg>
									</div>
									<img
										:src="getUrl(image)"
										alt=""
										class="
											rounded-lg
											object-fill
											h-full
											w-full
										"
										style="aspect-ratio: 4/3"
										@click="openMediaPopup(index)"
									/>
								</div>
							</div>
							<div
								v-if="files.length"
								class="mt-4 flex flex-col gap-2"
							>
								<div
									v-for="(file, index) in files"
									:key="index"
									class="
										text-neutral-400
										flex
										items-center
										gap-2
									"
								>
									<svg
										width="24"
										height="32"
										viewBox="0 0 24 32"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M0 4C0 1.79086 1.79086 0 4 0H14.5858C15.1162 0 15.6249 0.210714 16 0.585786L23.4142 8C23.7893 8.37507 24 8.88378 24 9.41421V28C24 30.2091 22.2091 32 20 32H4C1.79086 32 0 30.2091 0 28V4ZM15 7V3L21 9H17C15.8954 9 15 8.10457 15 7ZM17.7071 15.7071C18.0976 15.3166 18.0976 14.6834 17.7071 14.2929C17.3166 13.9024 16.6834 13.9024 16.2929 14.2929L11 19.5858L8.70711 17.2929C8.31658 16.9024 7.68342 16.9024 7.29289 17.2929C6.90237 17.6834 6.90237 18.3166 7.29289 18.7071L10.2929 21.7071C10.4804 21.8946 10.7348 22 11 22C11.2652 22 11.5196 21.8946 11.7071 21.7071L17.7071 15.7071Z"
											fill="#E5A42B"
										/>
									</svg>
									<span> {{ file.name }}</span>
									<span
										><svg
											@click="removeFile(index)"
											class="text-gray-400 cursor-pointer"
											width="20"
											height="20"
											viewBox="0 0 12 12"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M3.73483 3.73483C3.88128 3.58839 4.11872 3.58839 4.26517 3.73483L6.25 5.71967L8.23484 3.73483C8.38128 3.58839 8.61872 3.58839 8.76516 3.73483C8.91161 3.88128 8.91161 4.11872 8.76516 4.26517L6.78033 6.25L8.76516 8.23484C8.91161 8.38128 8.91161 8.61872 8.76516 8.76516C8.61872 8.91161 8.38128 8.91161 8.23484 8.76516L6.25 6.78033L4.26517 8.76516C4.11872 8.91161 3.88128 8.91161 3.73483 8.76516C3.58839 8.61872 3.58839 8.38128 3.73483 8.23484L5.71967 6.25L3.73483 4.26517C3.58839 4.11872 3.58839 3.88128 3.73483 3.73483Z"
												fill="currentColor"
											/>
										</svg>
									</span>
								</div>
							</div>
							<div class="w-full flex items-end gap-8 mt-4">
								<button
									@click="openModelUpload"
									type="button"
									class="
										button-p
										text-center
										bg-none
										shadow-none
										flex
										items-center
										justify-center
										btn--text
										w-fit
									"
								>
									<svg
										class="mr-2"
										width="16"
										height="16"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M8 0C6.57359 0 5.31176 0.560456 4.40576 1.34182C3.63985 2.00237 3.08479 2.8617 2.94223 3.725C1.26586 4.09512 0 5.55511 0 7.31818C0 9.36599 1.70754 11 3.78125 11H7.5V5.70711L5.35355 7.85355C5.15829 8.04882 4.84171 8.04882 4.64645 7.85355C4.45118 7.65829 4.45118 7.34171 4.64645 7.14645L7.64645 4.14645C7.84171 3.95118 8.15829 3.95118 8.35355 4.14645L11.3536 7.14645C11.5488 7.34171 11.5488 7.65829 11.3536 7.85355C11.1583 8.04882 10.8417 8.04882 10.6464 7.85355L8.5 5.70711V11H12.6875C14.5023 11 16 9.56949 16 7.77273C16 6.13656 14.7581 4.80411 13.1657 4.57898C12.9233 1.99944 10.6902 0 8 0Z"
											fill="currentColor"
										/>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M7.5 14.5V11H8.5V14.5C8.5 14.7761 8.27614 15 8 15C7.72386 15 7.5 14.7761 7.5 14.5Z"
											fill="currentColor"
										/>
									</svg>
									Tải lên tệp hoặc ảnh đính kèm
								</button>
							</div>
						</div>
						<div
							v-else
							class="
								w-full
								text-neutral-500
								bg-gray-100
								flex flex-col
								items-center
								justify-senter
								text-center
								gap-2
								rounded-lg
								p-8
								cursor-pointer
								border-2 border-dashed
								hover:border-yellow-500
							"
							@click="openModelUpload"
						>
							<svg
								width="48"
								height="48"
								viewBox="0 0 48 48"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M24 0C19.7208 0 15.9353 1.68137 13.2173 4.02545C10.9196 6.0071 9.25438 8.5851 8.82668 11.175C3.79759 12.2853 0 16.6653 0 21.9545C0 28.098 5.12261 33 11.3438 33H22.5V17.1213L16.0607 23.5607C15.4749 24.1464 14.5251 24.1464 13.9393 23.5607C13.3536 22.9749 13.3536 22.0251 13.9393 21.4393L22.9393 12.4393C23.5251 11.8536 24.4749 11.8536 25.0607 12.4393L34.0607 21.4393C34.6464 22.0251 34.6464 22.9749 34.0607 23.5607C33.4749 24.1464 32.5251 24.1464 31.9393 23.5607L25.5 17.1213V33H38.0625C43.507 33 48 28.7085 48 23.3182C48 18.4097 44.2743 14.4123 39.4971 13.7369C38.7699 5.99831 32.0707 0 24 0Z"
									fill="currentColor"
								/>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M22.5 43.5V33H25.5V43.5C25.5 44.3284 24.8284 45 24 45C23.1716 45 22.5 44.3284 22.5 43.5Z"
									fill="currentColor"
								/>
							</svg>
							<div class="font-semibold">
								Tải lên tệp đính kèm
							</div>
							<div class="text-sm">PNG, JPG & PDF</div>
						</div>
					</div>
				</div>
				<div class="flex md-down:flex-col w-full gap-4 mt-8">
					<div
						class="
							uppercase
							text-neutral-400 text-sm
							font-medium
							tracking-wide
							w-60
						"
					>
						ĐỐI TƯỢNG
					</div>
					<div class="w-full">
						<div class="flex gap-20 md-down:gap-8">
							<div
								class="flex items-center"
								@click="targetGroup = 'parents'"
							>
								<label class="mr-3 block text-neutral-600">
									Phụ huynh
								</label>
								<input
									name="notification-method"
									type="radio"
									class="
										h-4
										w-4
										text-yellow-600
										border-neutral-400 border-2
										focus:ring-yellow-600
									"
									value="parents"
									v-model="targetGroup"
								/>
							</div>
							<div
								class="flex items-center"
								@click="targetGroup = 'staffs'"
							>
								<label class="mr-3 block text-neutral-600">
									Trị liệu viên
								</label>
								<input
									name="notification-method"
									type="radio"
									class="
										h-4
										w-4
										text-yellow-600
										border-neutral-400 border-2
										focus:ring-yellow-600
									"
									value="staffs"
									v-model="targetGroup"
								/>
							</div>
						</div>
						<div class="w-full mt-6">
							<Multiselect
								track-by="value"
								:searchable="true"
								:allow-empty="false"
								:options="targetOptions"
								v-model="target"
								label="text"
								selectLabel=""
								placeholder="Chọn đối tượng báo cáo"
								selectedLabel=""
								deselectLabel="Ấn đễ bỏ chọn"
							>
								<template #noResult>
									Không tìm thấy kết quả
								</template>
							</Multiselect>
						</div>
						<div
							class="w-full mt-6"
							v-if="
								target &&
								[
									'custom_parent_of_students',
									'custom_staffs',
								].includes(target.value)
							"
						>
							<Multiselect
								track-by="value"
								:searchable="true"
								:options="targetOptionsCustom"
								:model-value="targetCustom"
								label="text"
								selectLabel=""
								:placeholder="
									targetGroup === 'staffs'
										? 'Chọn Trị liệu viên nhận thông báo'
										: 'Chọn Phụ huynh nhận thông báo'
								"
								selectedLabel=""
								deselectLabel="Ấn đễ bỏ chọn"
								@select="customSelected"
							>
								<template #noResult>
									Không tìm thấy kết quả
								</template>
							</Multiselect>
						</div>
						<div class="mt-6" v-if="targetGroup === 'staffs'">
							<div
								class="flex items-center justify-between mt-2"
								v-for="staff in staffsSelected"
								:key="staff.value"
							>
								<div>{{ staff.text }}</div>
								<div
									@click="deleteSelected(staff)"
									class="
										flex
										items-center
										text-blue-600
										hover:text-blue-700
										font-semibold
										cursor-pointer
										text-sm
									"
								>
									<svg
										class="mr-2"
										width="16"
										height="16"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M2.5 1C1.94772 1 1.5 1.44772 1.5 2V3C1.5 3.55228 1.94772 4 2.5 4H3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V4H13.5C14.0523 4 14.5 3.55228 14.5 3V2C14.5 1.44772 14.0523 1 13.5 1H10C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1H2.5ZM5.5 5C5.77614 5 6 5.22386 6 5.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5L5 5.5C5 5.22386 5.22386 5 5.5 5ZM8 5C8.27614 5 8.5 5.22386 8.5 5.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V5.5C7.5 5.22386 7.72386 5 8 5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V5.5Z"
											fill="currentColor"
										/>
									</svg>
									<span class="mt-0.5">Xoá</span>
								</div>
							</div>
						</div>
						<div class="mt-6" v-else>
							<div
								class="flex items-center justify-between mt-2"
								v-for="parent in parentsSelected"
								:key="parent.value"
							>
								<div>{{ parent.text }}</div>
								<div
									@click="deleteSelected(parent)"
									class="
										flex
										items-center
										text-blue-600
										hover:text-blue-700
										font-semibold
										cursor-pointer
										text-sm
									"
								>
									<svg
										class="mr-2"
										width="16"
										height="16"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M2.5 1C1.94772 1 1.5 1.44772 1.5 2V3C1.5 3.55228 1.94772 4 2.5 4H3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V4H13.5C14.0523 4 14.5 3.55228 14.5 3V2C14.5 1.44772 14.0523 1 13.5 1H10C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1H2.5ZM5.5 5C5.77614 5 6 5.22386 6 5.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5L5 5.5C5 5.22386 5.22386 5 5.5 5ZM8 5C8.27614 5 8.5 5.22386 8.5 5.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V5.5C7.5 5.22386 7.72386 5 8 5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V5.5Z"
											fill="currentColor"
										/>
									</svg>
									<span class="mt-0.5">Xoá</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div
			class="mt-10 flex items-center justify-center md:justify-end gap-6"
		>
			<button
				type="button"
				class="
					button-p
					text-center
					md-down:w-full
					w-fit
					md:px-10
					btn--ghost
				"
				@click="submit"
				:disabled="isSendDisable || inProgress"
			>
				Lưu bản nháp
			</button>
			<button
				type="button"
				class="button-p text-center md-down:w-full w-fit md:px-10"
				@click="openModal"
				:disabled="isSendDisable || inProgress"
			>
				Gửi thông báo
			</button>
		</div>
	</div>
</template>

<script>
import { $api } from '@/services';
import Multiselect from '@suadelabs/vue3-multiselect';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame';
import ConfirmSend from '@/views/notificationDetail/features/ConfirmSend';
import ViewPhoto from '@/components/common/ViewPhoto';

export default {
	name: 'NotificationCreate',

	components: { ViewPhoto, ConfirmSend, DaModalFrame, Multiselect },

	data() {
		return {
			boardings: [],
			title: '',
			content: '',
			target: null,
			targetCustom: null,
			modalIsOpen: false,
			notification: {
				files: [],
				images: [],
			},
			id: '',
			targetGroup: 'parents',
			files: [],
			images: [],
			inProgress: false,
			keys: [],
			students: [],
			staffs: [],
			staffsSelected: [],
			parentsSelected: [],
			imageShow: false,
			photosIndex: 0,
		};
	},

	watch: {
		targetGroup() {
			this.target = null;
			this.staffsSelected = [];
			this.parentsSelected = [];
		},
	},

	computed: {
		targetOptions() {
			if (this.targetGroup === 'staffs') {
				return [
					{
						value: 'all_staffs_in_org',
						text: 'TLV toàn cơ sở',
					},
					{
						value: 'all_day_care_staffs',
						text: 'Tất cả TLV bán trú',
					},
					{
						value: 'all_assigned_staffs',
						text: 'Tất cả TLV cá nhân',
					},
					{
						value: 'custom_staffs',
						text: 'Tuỳ chọn',
					},
				];
			}
			let targetOptions = [
				{
					value: 'all_parents_in_org',
					text: 'PH toàn cơ sở',
				},
			];
			let dayCare = this.boardings.map((item) => {
				return {
					value: item.id,
					text: 'PH lớp ' + item.name,
				};
			});
			return [
				...targetOptions,
				...dayCare,
				{
					value: 'custom_parent_of_students',
					text: 'Tuỳ chọn',
				},
			];
		},

		targetOptionsCustom() {
			const sId = this.staffsSelected.map((item) => item.value);
			const pId = this.parentsSelected.map((item) => item.value);
			if (this.targetGroup === 'staffs') {
				return this.staffs
					.map((item) => {
						return {
							value: item.id,
							text: item.name,
						};
					})
					.filter((item) => !sId.includes(item.value));
			}
			return this.students
				.map((item) => {
					return {
						value: item.id,
						text: 'PH bé ' + item.name,
					};
				})
				.filter((item) => !pId.includes(item.value));
		},

		isSendDisable() {
			return !this.title || !this.content || !this.target;
		},
	},

	created() {
		this.fetchBoardings();
		this.fetchStudents();
		this.fetchStaffs();
	},

	methods: {
		customSelected(value) {
			this.targetCustom = null;
			if (this.targetGroup === 'staffs') {
				const index = this.staffsSelected.indexOf(value);
				if (index !== -1) {
					this.staffsSelected.splice(index, 1);
				} else {
					this.staffsSelected.push(value);
				}
			} else {
				const index = this.parentsSelected.indexOf(value);
				if (index !== -1) {
					this.parentsSelected.splice(index, 1);
				} else {
					this.parentsSelected.push(value);
				}
			}
		},

		deleteSelected(value) {
			if (this.targetGroup === 'staffs') {
				const index = this.staffsSelected.indexOf(value);
				if (index !== -1) {
					this.staffsSelected.splice(index, 1);
				}
			} else {
				const index = this.parentsSelected.indexOf(value);
				if (index !== -1) {
					this.parentsSelected.splice(index, 1);
				}
			}
		},

		async fetchBoardings() {
			try {
				const res = await $api.boarding.getDayCareClasses();
				this.boardings = res?.data?.data || [];
			} catch (err) {
				console.log(err);
			}
		},

		async fetchStudents() {
			let role =
				this.$store.state.profile.staff.role === 'teacher'
					? 'staff'
					: 'org_admin';
			try {
				const {
					data: { data },
				} = await $api.student.getStudents(role, '');
				this.students = data;
			} catch (err) {
				console.log(err);
			}
		},

		async fetchStaffs() {
			try {
				const {
					data: { data },
				} = await $api.staff.getEmployees('');
				this.staffs = data;
			} catch (err) {
				console.log(err);
			}
		},

		openModelUpload() {
			const target = document.getElementById(
				'upload-images-notification'
			);
			target ? target.click() : '';
		},

		isImage(icon) {
			const ext = ['.jpg', '.jpeg', '.png', '.svg'];
			return ext.some((el) => icon.toLowerCase().endsWith(el));
		},

		uploadChange(event) {
			console.log('event', event?.target?.files[0]);
			let fileUploads = Array.from(event?.target?.files || []);
			if (!fileUploads || !fileUploads.length) {
				return;
			}
			fileUploads.forEach((file) => {
				if (this.isImage(file.name)) {
					this.images.push(file);
				} else {
					this.files.push(file);
				}
			});

			this.closeUpload();
		},

		closeUpload() {
			const target = document.getElementById(
				'upload-images-notification'
			);
			target ? (target.value = null) : '';
		},

		cancel() {
			this.modalIsOpen = false;
			this.modalType = '';
		},

		removeImage(index) {
			this.images.splice(index, 1);
		},

		removeFile(index) {
			this.files.splice(index, 1);
		},

		getUrl(file) {
			if (!file || file?.asset_url) {
				return file?.asset_url ?? '';
			}

			return URL.createObjectURL(file);
		},

		async submitConfirm() {
			this.inProgress = true;
			await this.submit(false);

			if (this.id) {
				await this.sendNotification();
			}
			this.inProgress = false;
		},

		async sendNotification() {
			try {
				await $api.notification.sendNotification(this.id);
				this.$store.dispatch('setAlertMessage', {
					message: 'Gửi thông báo thành công',
				});
				await this.$router.push(`/notifications/${this.id}`);
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},

		openModal() {
			this.notification = {
				content: this.content,
				subject: this.target?.text || '',
				title: this.title,
				files: this.files,
				images: this.images,
			};
			this.modalIsOpen = true;
		},

		async getSignatures() {
			const fileList = [...this.images, ...this.files];
			const {
				data: { data },
			} = await this.$api.file.getSignatures({
				mime_types: fileList.map((f) => f.type),
				prefix: 'notice_attachment',
			});

			if (data && data.length) {
				for (let i = 0; i < data.length; i++) {
					let formData = new FormData();
					formData.append(
						'AWSAccessKeyId',
						data[0]['AWSAccessKeyId'] || ''
					);
					formData.append('key', data[i].key || '');
					formData.append('acl', data[i].acl || '');
					formData.append(
						'Content-Type',
						data[i]['Content-Type'] || ''
					);
					formData.append('x-amz-signature', data[i].signature || '');
					formData.append('Signature', data[i].signature || '');
					formData.append('Policy', data[i].policy || '');
					formData.append(
						'success_action_status',
						data[i].success_action_status || ''
					);
					formData.append('file', fileList[i]);
					await this.uploadToS3(
						data[i].action,
						formData,
						fileList[i]
					);
				}
			}
		},

		async uploadToS3(url, payload, file) {
			const { data } = await this.$api.file.uploadToS3(url, payload);
			const keyData = data.toString().match('<Key>(.*)</Key>');
			const key = keyData && keyData.length ? keyData[1] : '';
			if (key) {
				this.keys.push({
					asset_key: key,
					mime_type: file.type,
					name: file.name,
				});
			}
		},

		async submit(isRedirect = true) {
			try {
				if (this.images.length || this.files.length) {
					await this.getSignatures();
				}
				const payload = {
					title: this.title,
					content: this.content,
					notice_attachments: this.keys,
					subject: [
						'all_parents_in_org',
						'is_all_staffs_in_org',
						'all_staffs_in_org',
						'custom_parent_of_students',
						'custom_staffs',
						'all_assigned_staffs',
						'all_day_care_staffs',
					].includes(this.target?.value)
						? this.target?.value
						: '',
					day_care_class_id: ![
						'all_parents_in_org',
						'is_all_staffs_in_org',
						'all_staffs_in_org',
						'custom_parent_of_students',
						'custom_staffs',
						'all_assigned_staffs',
						'all_day_care_staffs',
					].includes(this.target?.value)
						? this.target?.value
						: '',
					custom_staff_or_student_id_list:
						this.targetGroup === 'staffs'
							? this.staffsSelected.map((s) => s.value)
							: this.parentsSelected.map((s) => s.value),
				};
				const res = await $api.notification.createNotification(payload);
				this.id = res?.data?.data?.id;
				isRedirect ? await this.$router.push('/notifications') : '';
				this.$store.dispatch('setAlertMessage', {
					message: 'Thêm mới thông báo thành công',
				});
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},

		openMediaPopup(index) {
			this.imageShow = true;
			this.photosIndex = index;
		},
	},
};
</script>

<style lang="scss" scoped>
.title {
	font-weight: 600;
	box-shadow: none !important;

	&::placeholder {
		font-weight: normal;
	}
}
</style>
